export const colors = {
  main: '#663399',
  lilac: '#9d7cbf',
  grey: '#e0ebeb',
  black: 'black'
};
